import React, { useState } from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

function Faq() {
  const [questions] = useState([
    {
      question: 'What makes luxury furniture unique?',
      answer: 'Luxury furniture is made with premium materials, exceptional craftsmanship, and unique designs that stand out.'
    },
    {
      question: 'How do I maintain exclusive furniture?',
      answer: 'To maintain exclusive furniture, avoid direct sunlight, use appropriate cleaning solutions, and regularly polish wooden surfaces.'
    },
    {
      question: 'Is luxury furniture worth the investment?',
      answer: 'Yes, luxury furniture often lasts longer, adds aesthetic value, and can even appreciate over time.'
    },
    {
      question: 'Can I customize luxury furniture?',
      answer: 'Many brands offer customization options to suit your specific style and space requirements.'
    },
    {
      question: 'What materials are commonly used in exclusive furniture?',
      answer: 'Exclusive furniture typically uses materials like solid wood, marble, leather, and high-quality metals.'
    }
  ]);

  return (
    <div
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        maxWidth: '1200px',
        margin: '0 auto',
        textAlign: 'center'
      }}
    >
      {/* Image Banner */}
      <div
        style={{
          position: 'relative',
          marginBottom: '30px',
          overflow: 'hidden',
          borderRadius: '10px'
        }}
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTczE9aSGT9XwweJy3oJlwLJkU92Y_mgD3UeQ&s"
          alt="Luxury Furniture Banner"
          style={{
            width: '100%',
            maxHeight: '400px',
            objectFit: 'cover'
          }}
        />
        <h2
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '10px 20px',
            borderRadius: '5px',
            fontSize: '24px',
            textShadow: '1px 1px 5px black'
          }}
        >
          Dollar Furniture FAQs
        </h2>
      </div>

      {/* FAQ Section */}
      <div style={{ marginTop: '20px' }}>
        <h2 style={{ color: 'orange', marginBottom: '20px', fontSize: '28px' }}>Frequently Asked Questions</h2>
        <Collapse
          accordion
          style={{
            textAlign: 'left',
            maxWidth: '800px',
            margin: '0 auto',
            fontSize: '16px',
            borderRadius: '5px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
          }}
        >
          {questions.map((item, index) => (
            <Panel
              header={item.question}
              key={index}
              style={{
                backgroundColor: 'white',
                borderRadius: '5px',
                marginBottom: '10px',
                padding: '10px'
              }}
            >
              <p style={{ margin: '0', color: '#555' }}>{item.answer}</p>
            </Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
}

export default Faq;
